<template>
  <div>
    <div class="f16 subject">
      推荐货品
      <a target="_blank" :href="`${origin.VUE_APP_ZNT2}store`" class="f14 blue pull-right">更多 ></a>
    </div>
    <ul class="ul-cls optimize-list">
      <li v-for="item in goodList.slice(0, 5)" :key="item.goodsId" @click.stop="openLink(item, event)">
        <a class="tags" v-if="item.promotionType">
          <template v-if="item.promotionType === '折扣'">{{ item.promotionRate }}折优惠</template>
          <template v-if="item.promotionType === '直降'">直降{{ item.promotionRate }}元</template>
          <template v-if="item.promotionType === '买赠'">买{{ item.promotionStock }}赠{{ item.giftCount }}</template>
          <template v-if="item.promotionType === '集采'">集采</template>
        </a>
        <a class="img">
          <img :title="item.goodsNameStr || item.goodsName" :src="`${item.goodsImg}?imageView2/1/w/300/h/300`" v-if="item.goodsImg" />
          <img v-else src="./images/goods.png" :title="item.goodsNameStr || item.goodsName" />
        </a>
        <a class="text ellipsis_two" :title="item.goodsNameStr || item.goodsName">{{ item.goodsNameStr || item.goodsName }}</a>
        <div class="price">
          <span class="price-cur" v-if="item.sellFactPrice">{{ item.sellFactPrice }}</span>
          <span style="font-size: 14px" v-else>点击询价</span>

          <span class="price-discount" v-if="item.sellFactPrice !== item.sellPrice">¥{{ item.sellPrice }}</span>
          <img class="el-icon-shopping-cart-full pointer" @click.stop="addToCarts(item)" src="./images/car.png" />
        </div>
      </li>
    </ul>
    <ul class="ul-cls optimize-list mar-t20">
      <li v-for="item in goodList.slice(5, 10)" :key="item.goodsId" @click.stop="openLink(item, event)">
        <a class="tags" v-if="item.promotionType">
          <template v-if="item.promotionType === '折扣'">{{ item.promotionRate }}折优惠</template>
          <template v-if="item.promotionType === '直降'">直降{{ item.promotionRate }}元</template>
          <template v-if="item.promotionType === '买赠'">买{{ item.promotionStock }}赠{{ item.giftCount }}</template>
          <template v-if="item.promotionType === '集采'">集采</template>
        </a>
        <a class="img">
          <img :title="item.goodsNameStr || item.goodsName" :src="`${item.goodsImg}?imageView2/1/w/300/h/300`" v-if="item.goodsImg" />
          <img v-else src="./images/goods.png" :title="item.goodsNameStr || item.goodsName" />
        </a>
        <a class="text ellipsis_two" :title="item.goodsNameStr || item.goodsName">{{ item.goodsNameStr || item.goodsName }}</a>
        <div class="price">
          <span class="price-cur" v-if="item.sellFactPrice">{{ item.sellFactPrice }}</span>
          <span style="font-size: 14px" v-else>点击询价</span>
          <span class="price-discount" v-if="item.sellFactPrice !== item.sellPrice">¥{{ item.sellPrice }}</span>
          <img class="el-icon-shopping-cart-full pointer" @click.stop="addToCarts(item)" src="./images/car.png" />
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "MyInfo",
  props: {
    orderNums: Object,
  },
  data() {
    return {
      shoppingNum: 0,
      testList: [
        {
          goodsImg: "https://filesouthcdn.nxin.com/nxsc_161819542786807650023641336693.JPEG",
          sellFactPrice: 635.6,
          isPromotion: 0,
          goodsId: 337649387955,
          description: "整箱购",
          shopName: "南京科杰生物技术有限公司",
          sellPrice: 700,
          vipMoneyStr: "",
          spec: "元/袋",
          sellPriceStr: "700.00",
          isSupportInstallment: 0,
          shopIds: "6999867391440007475",
          goodsName: "科杰盐酸多西环素可溶性粉10%（100g/袋×50袋）整箱",
          isOptimization: 0,
          sellFactPriceStr: "635.60",
          promotionType: "",
          isPrescription: 1,
          totalSales: 75,
          isVIP: 1,
          currQuantity: 100000,
          goodsUrl: "https://filesouthcdn.nxin.com/nxsc_161819542786807650023641336693.JPEG",
          isPrevent: 0,
          objId: 12,
          activityType: "",
          isDel: 0,
          isSelfOperated: 0,
          status: 5,
        },
        {
          goodsImg: "https://filesouthcdn.nxin.com/nxsc_161819550633707793015044168942.JPEG",
          sellFactPrice: 645,
          isPromotion: 0,
          goodsId: 337649387956,
          description: "整箱购",
          shopName: "南京科杰生物技术有限公司",
          sellPrice: 1750,
          vipMoneyStr: "",
          spec: "元/箱",
          sellPriceStr: "1750.00",
          isSupportInstallment: 0,
          shopIds: "6999867391440007475",
          goodsName: "科杰替米考星预混剂20%（100g/袋×30袋）整箱购",
          isOptimization: 0,
          sellFactPriceStr: "645.00",
          promotionType: "",
          isPrescription: 1,
          totalSales: 74,
          isVIP: 1,
          currQuantity: 999,
          goodsUrl: "https://filesouthcdn.nxin.com/nxsc_161819550633707793015044168942.JPEG",
          isPrevent: 0,
          objId: 12,
          activityType: "",
          isDel: 0,
          isSelfOperated: 0,
          status: 5,
        },
      ],
      origin: process.env,
      // 优选好物
      goodList: [],
      // 货品详情地址
      goodDetailUrl: `${process.env.VUE_APP_APP}goods/queryGoodsDetailInfo/`,
      // 店铺详情地址
      shopDetailUrl: `${process.env.VUE_APP_APP}shopIndex/toShopIndex.do?shopId=`,
    };
  },
  computed: mapState({
    userIdentity: (state) => state.app.userIdentity,
    purchaseAuthority: (state) => state.app.purchaseAuthority,
  }),
  created() {
    const { ID, Type } = this.userIdentity;
    this.$store
      .dispatch("trade/getRecommendHotList", {
        page: 1,
        order_by: 1,
        page_size: 10,
        in_business_id: ID,
        in_business_type: Type === 0 ? 2 : 1,
        out_business_type: 12,
        tracking_code: "pc_home_member_accurate",
        use_always_buy: 1,
        use_accurate: 1,
      })
      .then((data) => {
        this.goodList = data;
      });
  },
  methods: {
    openLink(item) {
      const link = `${this.goodDetailUrl}${item.goodsId}?tracking_code=pc_home_member_accurate`;
      // this.$open({ url: link, title: "企联网-IAP", target: 1 });
      window.parent.postMessage({ fn: "open", data: { url: link, title: "企联网-IAP", target: 1 } }, "*");
    },
    // 加入购物车
    addToCarts(item) {
      console.log("加入购物车", item);
      this.$store
        .dispatch("trade/shoppingCartUpdate", { fromshopid: item.shopIds, goodscount: 1, goodsid: item.goodsId })
        // .dispatch("cart/addCart", {
        //   goodsId: item.goodsId,
        //   goodsQuantity: 1,
        //   fromShopId: item.shopIds,
        //   shopId: item.shopIds,
        // })
        .then((res) => {
          if (res.data) {
            // this.shoppingNum++;
            this.$message.success("添加成功！");
          } else {
            this.$message.error(res.msg || "系统繁忙");
          }
        });
    },
  },
};
</script>
